var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-switcher" },
    [
      _c(
        "div",
        { staticClass: "view-item", on: { click: _vm.selectMainTable } },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("table_chart")]),
          _vm._v("\n        Main Table\n    "),
        ]
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _vm._l(_vm.table.views, function (view) {
        return _c(
          "div",
          {
            key: view._id,
            staticClass: "view-item",
            on: {
              click: function ($event) {
                return _vm.selectView(view)
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("keyboard_tab"),
            ]),
            _vm._v("\n        " + _vm._s(view.name) + "\n        "),
            _c(
              "i",
              {
                staticClass: "material-icons edit-icon",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.editView(view)
                  },
                },
              },
              [_vm._v("edit")]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view-item add-new", on: { click: _vm.createNewView } },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
          _vm._v("\n        New View\n    "),
        ]
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "footer-text" }, [
        _vm._v(
          "\n        Create Views to persist filtering, sorting, and hiding fields without changing the main Table.\n    "
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }